import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Martina R.',
  initial: 'M',
  quote: 'Por fin alguien que te explica las cosas de forma simple. Dejé de dar vueltas y empecé a avanzar de verdad.'
}, {
  id: 2,
  name: 'Lucas G.',
  initial: 'L',
  quote: 'Había probado de todo y nada me funcionaba. Esta guía me dio la claridad que necesitaba para elegir un camino y seguirlo.'
}, {
  id: 9,
  name: 'Agustín V.',
  initial: 'A',
  quote: 'Por ese precio es un regalo. La cantidad de información valiosa que tiene es increíble. Pagué cursos mucho más caros que no me dieron ni la mitad.'
}, {
  id: 3,
  name: 'Sofía M.',
  initial: 'S',
  quote: 'Lo mejor es que va directo al punto. Sin relleno, sin promesas exageradas. Justo lo que necesitaba para empezar.'
}, {
  id: 4,
  name: 'Nicolás P.',
  initial: 'N',
  quote: 'En una semana ya tenía mi tienda armada y mis primeros anuncios corriendo. El paso a paso es muy claro.'
}, {
  id: 5,
  name: 'Valentina D.',
  initial: 'V',
  quote: 'No sabía nada de marketing digital. Hoy manejo mis propias campañas y estoy generando ventas todos los días.'
}, {
  id: 6,
  name: 'Tomás L.',
  initial: 'T',
  quote: 'La guía es oro puro. Me ahorró meses de prueba y error. Recomendado al 100%.'
}, {
  id: 7,
  name: 'Camila S.',
  initial: 'C',
  quote: 'Arranqué sin experiencia y en menos de un mes ya tenía resultados. El método funciona si lo seguís al pie de la letra.'
}, {
  id: 8,
  name: 'Federico A.',
  initial: 'F',
  quote: 'Lo que más me gustó es que no te venden humo. Es práctico, directo y con ejemplos reales.'
}];
export function TestimonialsMasonrySection() {
  return <section className="w-full bg-brand-bg py-20 md:py-28 px-6 relative overflow-hidden" data-id="element-240">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-green/5 rounded-full blur-3xl pointer-events-none" data-id="element-241" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-242">
        <div className="text-center max-w-3xl mx-auto mb-14" data-id="element-243">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} className="text-2xl md:text-4xl font-bold text-white mb-4" data-id="element-244">
            Más de 200 emprendedores ya dieron el salto digital
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1,
          ease: 'easeOut'
        }} className="text-lg text-brand-dark/60" data-id="element-245">
            Conocé las historias de quienes ya están generando ingresos con sus
            negocios online.
          </motion.p>
        </div>

        {/* Masonry grid */}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-5 space-y-5" data-id="element-246">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index % 5 * 0.08
        }} className="bg-brand-card rounded-2xl p-6 border border-white/10 break-inside-avoid relative" data-id="element-247">
              <QuoteIcon className="absolute top-4 right-4 w-7 h-7 text-white/[0.06] rotate-180" data-id="element-248" />

              <div className="flex items-center mb-3" data-id="element-249">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 text-yellow-400 fill-current" data-id="element-250" />)}
              </div>

              <p className="text-brand-dark/70 leading-relaxed mb-5 relative z-10 text-sm md:text-base" data-id="element-251">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center" data-id="element-252">
                <div className="w-9 h-9 rounded-full bg-brand-green/15 flex items-center justify-center text-brand-green font-semibold text-sm" data-id="element-253">
                  {testimonial.initial}
                </div>
                <div className="ml-3" data-id="element-254">
                  <span className="font-semibold text-brand-dark text-sm" data-id="element-255">
                    {testimonial.name}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* CTA below testimonials */}
        <motion.div className="mt-14 text-center flex flex-col items-center gap-5" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-256">
          <p className="text-xl md:text-2xl font-bold text-white" data-id="element-257">
            👉 Vos podés ser el próximo resultado
          </p>
          <a href="https://www.emprende-digital.com/cart/51742249156888:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-brand-green hover:bg-brand-green-hover text-brand-bg font-bold text-lg px-10 py-4 rounded-xl transition-colors duration-200 shadow-lg shadow-brand-green/20" data-id="element-258">
            🔥 Empezar ahora
          </a>
        </motion.div>
      </div>
    </section>;
}